import React, { useState, useEffect } from 'react';
import { AxiosAPI } from '../../../../../../helpers/AxiosAPI';
import {
  putAPI_Update_Image,
  putAPI_Delete_Image,
} from '../../../../../../constants/APIs';
import TagsInput from 'react-tagsinput';
import 'react-tagsinput/react-tagsinput.css';
import {
  Row,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
} from 'reactstrap';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import Validation from '../../../../../../components/Validation';
import IntlMessages from '../../../../../../helpers/IntlMessages';
import CopyToClipboard from 'react-copy-to-clipboard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/free-solid-svg-icons';
import LanguageTabs from '../../components/LanguageTabs/LanguageTabs';
const Checkmark = ({ selected }) => (
  <div
    style={
      selected
        ? { left: '4px', top: '4px', position: 'absolute', zIndex: '1' }
        : { display: 'none' }
    }
  >
    <svg
      style={{ fill: 'white', position: 'absolute' }}
      width="24px"
      height="24px"
    >
      <circle cx="12.5" cy="12.2" r="8.292" />
    </svg>
    <svg
      style={{ fill: '#06befa', position: 'absolute' }}
      width="24px"
      height="24px"
    >
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
    </svg>
  </div>
);

const imgStyle = {
  transition: 'transform .135s cubic-bezier(0.0,0.0,0.2,1),opacity linear .15s',
};
const selectedImgStyle = {
  transform: 'translateZ(0px) scale3d(0.9, 0.9, 1)',
  transition: 'transform .135s cubic-bezier(0.0,0.0,0.2,1),opacity linear .15s',
};
const cont = {
  backgroundColor: '#eee',
  cursor: 'pointer',
  overflow: 'hidden',
  position: 'relative',
};

const UserUploadSelectedImage = ({
  index,
  photo,
  allphotos,
  margin,
  folders,
  direction,
  top,
  left,
  selected,
  ParentUserUploadImage,
  chosenImage,
  ParentUserDeleteImage,
  ParentUserEditImage,
  userName,
  locale,
  serviceProvider,
  LoadData
}) => {
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);
  const [isSelected, setIsSelected] = useState(selected);
  const [selectedImg, setselectedImg] = useState(chosenImage);
  const [deleteVisible, setDeleteVisible] = useState(false);
  const [imageTags, setimageTags] = useState(photo.tags);
  const [imageCaption, setImageCaption] = useState("");
  const [folder, setFolder] = useState(photo?.folder);
  const [editVisible, seteditVisible] = useState(false);
  const [selectedLang, setSelectedLang] = useState(locale);
  const [captions, setCaptions] = useState(photo.captions || {});
  const [tagInputValue, setTagInputValue] = useState('');
  //calculate x,y scale
  const sx = (100 - (30 / photo.width) * 100) / 100;
  const sy = (100 - (30 / photo.height) * 100) / 100;
  selectedImgStyle.transform = `translateZ(0px) scale3d(${sx}, ${sy}, 1)`;

  if (direction === 'column') {
    cont.position = 'absolute';
    cont.left = left;
    cont.top = top;
  }

  useEffect(() => {
    setIsSelected(selected);
    // console.log(photo.captions, imageCaption);
    // console.log(photo, folders, 'photo', captions, photo.caption, captions.filter(c => c.languageCode == selectedLang)[0]?.statement);
    setImageCaption(photo.caption === "" ? captions.filter(c => c.languageCode == selectedLang)[0]?.statement : photo.caption);
  }, [selected, photo]);

  const handleOnClick = (id, event) => {
    // setselectedImg(id)
    ParentUserUploadImage(id);
  };
  const handleTagChange = (event) => {
    setimageTags(event);
  };

  const handleFolderChange = (event) => {
    setFolder(event.target.value);
  };

  const toggle = () => {
    setDeleteVisible(!deleteVisible);
  };
  const toggleedit = () => {
    LoadData();
    setImageCaption("");
    setCaptions(captions.filter(l => l.languageCode !== selectedLang))
    seteditVisible(!editVisible);
  };
  const handleChange = (event) => {
    let lst = [...captions];
    let ovj = lst.filter((c) => c.languageCode == selectedLang)[0];
    if (ovj) {
      ovj.statement = event.target.value;
      lst.filter((c) => c.languageCode == selectedLang)[0] = ovj;
    } else {
      lst.push({
        languageCode: selectedLang,
        statement: event.target.value,
      });
    }
    setImageCaption(event.target.value);
    setCaptions(lst);
  };

  const handleDelete = () => {
    AxiosAPI({
      method: 'put',
      url: `${putAPI_Delete_Image}/${photo.id}`,
      data: {
        deleter: userName,
      },
    })
      .then((res) => {
        toggle();
        ParentUserDeleteImage(photo.id);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleUpdate = () => {
    let updatedTags = Array.isArray(imageTags) ? [...imageTags] : [];
    if (tagInputValue && tagInputValue.trim() !== '') {
      const splitTags = tagInputValue
        .split(',')
        .map(tag => tag.trim())
        .filter(tag => tag !== '');

      updatedTags = [...updatedTags, ...splitTags];
    }

    updatedTags = [...new Set(updatedTags)];

    AxiosAPI({
      method: 'put',
      url: `${putAPI_Update_Image}/${photo.id}`,
      data: {
        deleter: userName || 'dashboard',
        tags: updatedTags,
        path: folder,
        captions: captions,
        caption: imageCaption,
      },
    })
      .then((res) => {
        if (
          res.data.HttpStatusCode !== undefined &&
          res.data.HttpStatusCode === 400 &&
          res.data.Messages !== undefined &&
          res.data.Messages !== null &&
          res.data.Messages.length > 0
        ) {
          setMsg(res.data.Messages);
          setOpen(true);
        } else {
          setimageTags(updatedTags);
          setTagInputValue('');
          LoadData();
          toggleedit();
          ParentUserEditImage(photo.id, updatedTags);
        }
      })
      .catch((err) => console.log(err));
  };

  const setLanguage = (e) => {
    var lan = e;
    if (e === 'zh-TW') {
      lan = 'hk';
    }
    setSelectedLang(lan);
  };
  const generateDeleteButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="8" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal isOpen={deleteVisible} toggle={toggle}>
                <ModalHeader toggle={toggle}>
                  <span role="img" aria-label="warning">
                    ⚠️
                  </span>
                  This image will be deleted!
                </ModalHeader>
                <ModalBody>
                  <Button
                    color="danger"
                    onClick={() => handleDelete()}
                    size="xs"
                  >
                    <IntlMessages id="dashboards.delete" />
                  </Button>
                  <Button
                    className="ml-2"
                    color="dark"
                    outline
                    size="xs"
                    onClick={toggle}
                  >
                    <IntlMessages id="pages.cancel" />
                  </Button>
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };

  const generateEditButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="8" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal isOpen={editVisible} toggle={toggleedit}>
                <ModalHeader toggle={toggleedit}>
                  <div>
                    {' '}
                    Gallery Information
                    <p className="mt-2">
                      {' '}
                      Image captions are shown on the images, and both captions
                      and tags are AI-searched to surface the most relevant
                      images to customers.
                    </p>
                  </div>{' '}
                </ModalHeader>

                <ModalBody>
                  <Row className="mb-4">
                    <Colxx xxs="12">
                      <TagsInput
                        className="input_sty"
                        value={imageTags || []}
                        inputValue={tagInputValue}
                        onChangeInput={(val) => setTagInputValue(val)}
                        onChange={(tags) => setimageTags(tags)}
                        placeHolder="Add a tag and press enter"
                        title="Add a tag and press enter"
                        addKeys={[9, 13, 188]}
                      />
                    </Colxx>
                  </Row>
                  <Row className="mb-3">
                    <Colxx xxs="12">
                      <LanguageTabs
                        selectedTab={
                          selectedLang === 'hk' ? 'zh-TW' : selectedLang
                        }
                        setLanguage={(e) => setLanguage(e)}
                      ></LanguageTabs>
                    </Colxx>
                  </Row>
                  <Row className="mb-4">
                    <Colxx xxs="12">
                      <Input
                        className="input_sty"
                        type="text"
                        name="caption"
                        placeHolder="Add a caption"
                        value={imageCaption}
                        disabled={photo?.cratedBy === 'SynXis' ? true : false}
                        onChange={(event) => handleChange(event)}
                      />
                    </Colxx>
                  </Row>
                  {photo?.cratedBy && photo?.cratedBy !== '' && (
                    <Row className="mb-2">
                      <Colxx xxs="12">Created By : {photo?.cratedBy}</Colxx>
                    </Row>
                  )}
                  <Row className="mb-2 ">
                    <Colxx xxs="12">
                      <Label>Move to Folder :</Label>{' '}
                      <Input
                        className="input_sty"
                        type="select"
                        name="folder"
                        // placeHolder="Folder"
                        value={folder}
                        placeholder=" Please select to Move to Folder"
                        onChange={(event) => handleFolderChange(event)}
                      >
                        <option value={''}>
                          Please select to Move to Folder{' '}
                        </option>
                        {folders?.map((m) => (
                          <option value={m?.folderPath + '/' + m?.folderName}>
                            {m?.folderName}
                          </option>
                        ))}
                      </Input>
                    </Colxx>
                  </Row>

                  <Row className="mb-2">
                    <Colxx xxs="12">
                      <div>
                        Path:{' '}
                        <a target="_blank" href={photo?.src}>
                          {photo?.src}
                        </a>{' '}
                        |{' '}
                      </div>
                      <CopyToClipboard text={photo?.src}>
                        <Button
                          outline
                          size="xs"
                          style={{
                            float: 'left',
                            color: 'grey',
                            border: 'none',
                            paddingLeft: '1em',
                          }}
                        >
                          <FontAwesomeIcon icon={faCopy}></FontAwesomeIcon>
                        </Button>
                      </CopyToClipboard>
                    </Colxx>
                  </Row>
                </ModalBody>
                <ModalFooter>
                  <Button
                    color="secondary"
                    onClick={() => handleUpdate()}
                    size="xs"
                  >
                    <IntlMessages id="dashboards.update" />
                  </Button>
                  <Button
                    className="ml-2"
                    color="dark"
                    outline
                    size="xs"
                    onClick={toggleedit}
                  >
                    <IntlMessages id="pages.cancel" />
                  </Button>
                </ModalFooter>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };
  return (
    <div
      style={{
        margin,
        position: 'relative',
        width: photo.width,
        height: photo.height,
        ...(allphotos !== undefined &&
          allphotos !== null &&
          allphotos?.length < 3
          ? { maxWidth: '300px', maxHeight: '300px' }
          : ''),
        ...cont,
      }}
      className={chosenImage !== photo.id ? 'not-selected' : ''}
    >
      {/* <Checkmark selected={chosenImage == photo.id ? true : false} /> */}
      <Checkmark
        selected={photo?.selected}
        className={!photo?.selected ? 'not-selected' : ''}
      />
      {photo.src.includes('.mp4') ? (
        <iframe
          src={photo.src}
          style={{
            width: '100%',
            height: '100%',

            ...(chosenImage === photo.id ? selectedImgStyle : imgStyle),
          }}
          onClick={(event) => handleOnClick(photo.id, event)}
        />
      ) : (
        <img
          alt={photo.caption}
          style={{
            width: '100%',
            height: '100%',

            ...(chosenImage === photo.id ? selectedImgStyle : imgStyle),
          }}
          {...photo}
          onClick={(event) => handleOnClick(photo.id, event)}
        />
      )}
      <a href="#/" className="edit" onClick={toggleedit}>
        {' '}
        <i className="glyph-icon simple-icon-pencil" />{' '}
      </a>
      <a href="#/" className="remove" onClick={toggle}>
        {' '}
        <i className="glyph-icon simple-icon-trash" />{' '}
      </a>
      <style>{`.not-selected:hover{outline:2px solid #06befa}`}</style>
      {generateDeleteButton()}
      {generateEditButton()}
      <span
        className={`badge badge-pill badge-primary
                   position-absolute badge-top-left-2`}
      >
        {photo.caption}
      </span>
      <Validation
        open={open}
        messages={msg}
        toggle={() => {
          setOpen(!open);
        }}
      ></Validation>
    </div>
  );
};

export default UserUploadSelectedImage;
